import * as React from 'react'
interface NetworkContextType {
  isOnline: boolean
  setIsOnline: (isOnline: boolean) => void
}

export const NetworkContext = React.createContext({} as NetworkContextType)

export const useNetwork = (): NetworkContextType => {
  const context = React.useContext(NetworkContext)
  if (!context) {
    throw new Error('useNetwork must be used within a NetworkProvider')
  }
  return context
}

export const NetworkProvider = ({ children }: { children: React.ReactNode }): React.ReactNode => {
  const [isOnline, setIsOnline] = React.useState(true)

  const contextValue = React.useMemo(() => ({ isOnline, setIsOnline }), [isOnline, setIsOnline])

  return <NetworkContext.Provider value={contextValue}>{children}</NetworkContext.Provider>
}
